import type { FarmerShop } from "./types/farmer-shop";

export function formatShopLocation(
  shop: Pick<
    FarmerShop,
    "county" | "subCounty" | "ward" | "location" | "subLocation" | "village"
  >,
) {
  return [
    shop.county,
    shop.subCounty,
    shop.ward,
    shop.location,
    shop.subLocation,
    shop.village,
  ]
    .filter(Boolean)
    .join(", ");
}
